module.exports = __webpack_public_path__ + "static/media/1030866.a38fc1c4.png";